module.exports = __webpack_public_path__ + "img/2019homepark-4.53bea79f.jpeg";